/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum ActivityType {
    Break = 'Break',
    DayRest = 'DayRest',
    WeeklyRest = 'WeeklyRest'
}

export function ActivityTypeFromJSON(json: any): ActivityType {
    return ActivityTypeFromJSONTyped(json, false);
}

export function ActivityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityType {
    return json as ActivityType;
}

export function ActivityTypeToJSON(value?: ActivityType | null): any {
    return value as any;
}

